import React, { useMemo } from 'react';

import useLoginModal from '~/App/shared/hooks/use-login-modal';
import { isMobileBrowser } from '~/App/helpers/is-mobile-browser';
import { Loading } from '../Loading/Loading';
import { useAppContext } from '~/App/contexts/App';
import { useAuthenticationContext } from '~/App/contexts/Authentication';

export function Spinner() {
  const status = useAuthenticationContext((x) => x.status);
  const userAgent = useAppContext((x) => x.userAgent);
  const loginModal = useLoginModal();

  const message = useMemo(() => {
    if (!status) {
      return 'Signera med Mobilt BankID';
    }
    if(status === 'aborting') {
      return null
    }

    if (isMobileBrowser(userAgent)) {
      return status === 'signing'
        ? 'Skriv in din säkerhetskod och välj Legitimera eller Skriv under.'
        : loginModal.mobileInitView
        ? 'Försöker starta BankID-appen.'
        : 'Starta BankID-appen.';
    }

    return status === 'signing'
      ? 'Skriv in din säkerhetskod i BankID-appen och välj Legitimera eller Skriv under.'
      : 'Starta BankID-appen.';
  }, [loginModal.mobileInitView, status, userAgent]);

  return <Loading children={message} />;
}
